import { render, staticRenderFns } from "./Absences.vue?vue&type=template&id=22b3236e"
import script from "./Absences.vue?vue&type=script&lang=js"
export * from "./Absences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports